export function getStartPin(): string {
  return (
    ` <svg xmlns="http://www.w3.org/2000/svg" width="32" height="50" viewBox="0 0 32 50" data-qa-element-id="route_pin_start"> ` +
    getPinSvgData('green') +
    `<circle cx="16" cy="16" r="13" fill="white"/>
      <path fill='green' d="M139 1263 c-11 -13 -14 -123 -16 -602 -3 -645 -4 -633 55 -639 28 -3 101 39 489 280 252 155 470 293 485 306 35 30 35 54 0 84 -15 13 -233 150 -484 306 -469 290 -497 304 -529 265z"
          fill="black"
          transform="scale(0.015) translate(540 400)"/>
    </svg>`
  );
}

export function getFinishPin(): string {
  return (
    `<svg viewBox="0 0 32 48" xmlns="http://www.w3.org/2000/svg" data-qa-element-id="route_pin_end">` +
    getPinSvgData('red') +
    `<defs>
            <pattern id="checkered" width="12" height="12" patternUnits="userSpaceOnUse">
            <rect width="6" height="6" fill="white"/>
            <rect x="6" y="6" width="6" height="6" fill="white"/>
            <rect x="6" width="6" height="6" fill="black"/>
            <rect y="6" width="6" height="6" fill="black"/>
            </pattern>
        </defs>

        <circle cx="16" cy="16" r="13" stroke="black" stroke-width="0" fill="url(#checkered)"/>
    </svg>`
  );
}

export function getNumPin(num: number, fillColor: string): string {
  return (
    ` <svg xmlns="http://www.w3.org/2000/svg"  width="32" height="50" viewBox="0 0 32 50" data-qa-element-id="route_pin_number_${num}">` +
    getPinSvgData(fillColor) +
    `<circle cx="16" cy="16" r="13" fill="white"/>
        <circle cx="16" cy="16" r="13" fill="white"/>
        <text x="16" y="21" font-size="13" text-anchor="middle" fill="black" font-weight="bold">${num}</text>
      </svg>`
  );
}

function getPinSvgData(fillColor: string) {
  return `<path fill=${fillColor} stroke-width="1" d="M 16,0.5 C 7.4396,0.5 0.5,7.4396 0.5,16 0.5,20.2802 2.0133,23.9336 5.0398,26.9602 16,37.9203 13,45 16,47.3635 19,45 16,37.9203 26.9602,26.9602 29.9867,23.9336 31.5,20.2802 31.5,16 31.5,7.4396 24.5604,0.5 16,0.5 Z"></path>`;
}

export function getEventSvg(isHighlighted: boolean): string {
  return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" data-qa-element-id="pin_event">
  <path d="M50 10 L10 90 H90 L50 10 Z" fill=${isHighlighted ? '#FFC107' : '#BBB'}></path>
  <circle cx="50" cy="75" r="5" fill="#000000"></circle>
  <rect x="47" y="35" width="6" height="30" fill="#000000"></rect>
</svg>`;
}
